import React from 'react';
import {LoadingBar as OrigLoadingBar} from 'react-redux-loading-bar';
import {connect} from 'react-redux';
import {getOutstandingLoadingBarRequestsCount} from '../store/selectors';

const LoadingBar = (props) => <OrigLoadingBar {...props} />;

export default connect((state) => ({loading: getOutstandingLoadingBarRequestsCount(state)}))(LoadingBar);
